import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X } from 'lucide-react';
import { useState } from 'react';
import { useSiteSettings } from '../context/SiteSettingsContext';
import { resolveImageUrl } from '../lib/imageUpload';

const Navigation = () => {
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();
  const { settings } = useSiteSettings();

  const isActive = (path) => location.pathname === path;

  return (
    <nav className="glass-nav fixed top-0 w-full z-50">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="flex justify-between items-center h-20">
          <Link to="/" className="flex items-center gap-2" data-testid="nav-logo">
            {settings.logo_url ? (
              <img src={resolveImageUrl(settings.logo_url)} alt={settings.site_name} className="h-10 md:h-12 w-auto object-contain" data-testid="nav-logo-image" />
            ) : (
              <span className="text-2xl md:text-3xl font-bold" style={{ fontFamily: 'var(--heading-font)' }}>
                {settings.site_name}
              </span>
            )}
          </Link>

          {/* Desktop Menu */}
          <div className="hidden md:flex items-center gap-8">
            <Link
              to="/"
              className={`text-lg font-medium transition-colors ${
                isActive('/') ? 'text-black border-b-2 border-[var(--accent)]' : 'text-zinc-600 hover:text-black'
              }`}
              data-testid="nav-home"
            >
              HOME
            </Link>
            <Link
              to="/classes"
              className={`text-lg font-medium transition-colors ${
                isActive('/classes') ? 'text-black border-b-2 border-[var(--accent)]' : 'text-zinc-600 hover:text-black'
              }`}
              data-testid="nav-classes"
            >
              CLASSES
            </Link>
            <Link
              to="/class-passes"
              className={`text-lg font-medium transition-colors ${
                isActive('/class-passes') ? 'text-black border-b-2 border-[var(--accent)]' : 'text-zinc-600 hover:text-black'
              }`}
              data-testid="nav-class-passes"
            >
              CLASS PASSES
            </Link>
            <Link
              to="/studios"
              className={`text-lg font-medium transition-colors ${
                isActive('/studios') ? 'text-black border-b-2 border-[var(--accent)]' : 'text-zinc-600 hover:text-black'
              }`}
              data-testid="nav-studios"
            >
              STUDIOS
            </Link>
            <Link
              to="/events"
              className={`text-lg font-medium transition-colors ${
                isActive('/events') ? 'text-black border-b-2 border-[var(--accent)]' : 'text-zinc-600 hover:text-black'
              }`}
              data-testid="nav-events"
            >
              EVENTS
            </Link>
          </div>

          {/* Mobile Menu Button */}
          <button
            className="md:hidden"
            onClick={() => setIsOpen(!isOpen)}
            data-testid="mobile-menu-button"
          >
            {isOpen ? <X size={28} /> : <Menu size={28} />}
          </button>
        </div>

        {/* Mobile Menu */}
        {isOpen && (
          <div className="md:hidden pb-4 border-t border-zinc-200 mt-2" data-testid="mobile-menu">
            <div className="flex flex-col gap-4 pt-4">
              <Link
                to="/"
                className={`text-lg font-medium ${
                  isActive('/') ? 'text-black' : 'text-zinc-600'
                }`}
                onClick={() => setIsOpen(false)}
                data-testid="mobile-nav-home"
              >
                HOME
              </Link>
              <Link
                to="/classes"
                className={`text-lg font-medium ${
                  isActive('/classes') ? 'text-black' : 'text-zinc-600'
                }`}
                onClick={() => setIsOpen(false)}
                data-testid="mobile-nav-classes"
              >
                CLASSES
              </Link>
              <Link
                to="/class-passes"
                className={`text-lg font-medium ${
                  isActive('/class-passes') ? 'text-black' : 'text-zinc-600'
                }`}
                onClick={() => setIsOpen(false)}
                data-testid="mobile-nav-class-passes"
              >
                CLASS PASSES
              </Link>
              <Link
                to="/studios"
                className={`text-lg font-medium ${
                  isActive('/studios') ? 'text-black' : 'text-zinc-600'
                }`}
                onClick={() => setIsOpen(false)}
                data-testid="mobile-nav-studios"
              >
                STUDIOS
              </Link>
              <Link
                to="/events"
                className={`text-lg font-medium ${
                  isActive('/events') ? 'text-black' : 'text-zinc-600'
                }`}
                onClick={() => setIsOpen(false)}
                data-testid="mobile-nav-events"
              >
                EVENTS
              </Link>
            </div>
          </div>
        )}
      </div>
    </nav>
  );
};

export default Navigation;